import { setMode } from "../shared/globalState/a";

export type CommandMethod = ((arg?: any) => void) | null;
export type UndoMethod = (() => void) | null;

export interface Language {
    id: string;
    name: string;
}

export class Command {
    public type: string;
    public name: string;
    public description: string;
    public shortcutEn: string | null;
    public shortcutRu: string | null;
    public method: CommandMethod;
    public undo: UndoMethod;
    public updatedShortcut?: string;

    constructor(
        type: string, 
        name: string, 
        description: string, 
        shortcutEn: string | null, 
        shortcutRu: string | null, 
        method: CommandMethod, 
        undo: UndoMethod
    ) {
        this.type = type;
        this.name = name;
        this.description = description;
        this.shortcutEn = shortcutEn;
        this.shortcutRu = shortcutRu;
        this.method = method;
        this.undo = undo;
    }

    public run(arg?: any): void {
        if (arg instanceof KeyboardEvent) {
            arg.preventDefault();
        }
        setMode(this.type);
        if (this.method) {
            this.method(arg); 
        }
    }

    public undoCommand(model?: any): void {
        if (this.undo) {
            this.undo();
        }
    }

    public getCommandType(): string {
        return this.type;
    }

    public getCommandDescription(): string {
        return this.description;
    }

    public getCommandShortcut(): string | null {
        return this.shortcutEn;
    }

    public translateDescription(lang: string): void {
        // Метод для перевода описания команды в зависимости от языка
        // TODO: Implement translation logic
    }

    /**
     * Метод для сериализации команды
     */
    public serialize(): string {
        return JSON.stringify({
            type: this.type,
            name: this.name,
            description: this.description,
            shortcutEn: this.shortcutEn,
            shortcutRu: this.shortcutRu,
            // Note: methods are not serialized as they are functions
        });
    }

    /**
     * Метод для десериализации команды
     */
    public deserialize(data: string): void {
        const parsed = JSON.parse(data);
        this.type = parsed.type;
        this.name = parsed.name;
        this.description = parsed.description;
        this.shortcutEn = parsed.shortcutEn;
        this.shortcutRu = parsed.shortcutRu;
        // Note: methods need to be set separately after deserialization
    }

    public getClone(shortcut: string): Command {
        const command = new Command(
            this.type, 
            this.name, 
            this.description, 
            shortcut, 
            '', 
            this.method, 
            this.undo
        );
        return command;
    }
}

export const languages: Language[] = [
    {
        id: 'en',
        name: 'English',
    },
    {
        id: 'ru',
        name: 'Русский',
    },
    {
        id: 'kz',
        name: 'қазақ тілі',
    },
    {
        id: 'uz',
        name: "o'zbek tili",
    },
    {
        id: 'tr',
        name: 'Türkçe',
    }
    //... more languages here
];
